import { useEffect } from 'react'
import { useSettings } from '../hooks/useSettings'

interface SettingsDrawerProps {
  open: boolean
  onClose: () => void
}

export default function SettingsDrawer({ open, onClose }: SettingsDrawerProps) {
  const [settings, updateSettings] = useSettings()

  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="Settings"
    >
      {/* Backdrop */}
      <button
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
        aria-label="Close settings"
      />
      {/* Panel */}
      <div
        className="relative w-full sm:max-w-sm bg-[var(--bg-surface-1)] sm:rounded-2xl rounded-t-2xl border border-[var(--border-subtle)] shadow-xl p-5"
        style={{ boxShadow: '0 8px 32px rgba(26, 22, 20, 0.18)' }}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-semibold" style={{ color: 'var(--text-primary)' }}>
            Settings
          </h2>
          <button
            onClick={onClose}
            className="text-[var(--text-secondary)] hover:text-[var(--text-primary)] text-xl leading-none px-2"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <label className="flex items-start gap-3 cursor-pointer py-2">
          <input
            type="checkbox"
            checked={settings.textInputEnabled}
            onChange={(e) => updateSettings({ textInputEnabled: e.target.checked })}
            className="mt-1 accent-[var(--accent)]"
          />
          <div>
            <div className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>
              Show text input
            </div>
            <div className="text-xs mt-0.5" style={{ color: 'var(--text-secondary)' }}>
              The Lost Club is voice-first. Enable this if your microphone isn't working
              or you prefer to type.
            </div>
          </div>
        </label>
      </div>
    </div>
  )
}
